import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Signed in");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-3.5rem)] grid lg:grid-cols-2 items-stretch">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-zinc-950 text-white">
        <div className="flex items-center gap-2.5">
          <img src="/favicon.svg" alt="" aria-hidden="true" className="w-7 h-7" />
          <div className="font-heading font-black text-2xl tracking-tight">LeadBridge</div>
        </div>
        <div>
          <div className="font-heading font-black text-5xl tracking-tight leading-none">
            Welcome back, <br />closer.
          </div>
          <div className="font-mono text-xs tracking-widest uppercase text-zinc-400 mt-6">Inbound lead console</div>
        </div>
        <div className="text-xs font-mono tracking-widest uppercase text-zinc-500">v1.0 · 2026</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="text-[10px] font-mono tracking-[0.3em] uppercase text-zinc-500 mb-2">Sign in</div>
          <h1 className="font-heading font-black text-4xl tracking-tight leading-none mb-8">Login to your console</h1>

          <div className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-600">Email</Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="btn-sharp mt-1 h-11"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-600">Password</Label>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="btn-sharp mt-1 h-11"
                data-testid="login-password-input"
              />
            </div>
            {err && (
              <div className="text-sm text-[#E63946] font-medium" data-testid="login-error">
                {err}
              </div>
            )}
            <Button
              type="submit"
              disabled={busy}
              className="w-full btn-sharp bg-[#0055FF] hover:bg-[#0044CC] text-white h-12 font-bold tracking-wider uppercase text-xs"
              data-testid="login-submit-button"
            >
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </div>

          <div className="mt-8 text-sm text-zinc-600">
            No account?{" "}
            <Link to="/register" className="font-bold text-black underline" data-testid="login-register-link">
              Register as an agent
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
